import { replaceStringVars } from './replaceStringVars';

export const initMessagesObject = (messages, vars) => {
  if (!vars) {
    return messages || {};
  }
  return Object.keys(messages).reduce((acc, key) => {
    return {
      ...acc,
      [key]: replaceStringVars(messages[key], vars),
    };
  }, {});
};
